<template>
  <div class="platform">
    <transition-group
      appear
      appear-active-class="transition-group-appear-active"
      appear-to-class="transition-group-appear-to"
      name="transition-group"
      tag="div"
    >
      <platform-notifications-group class="group" :active="index === 0" v-for="(group, index) in platformNotifications.slice(0, 3)" :key="group.tickerID">
        <template v-for="(notification, aindex) in group.notifications.slice(0, 3)">
            <platform-notification
              :active="aindex === 0"
              :key="notification.id"
              :notification="notification"
              :group="group"
              :notificationsCount="group.notifications.length"
            />
        </template>
      </platform-notifications-group>
    </transition-group>
    <archive-notification-modal
      v-show="pendingArchieveConfirmationAlertData"
    />
  </div>
</template>


<script>
import { mapState } from 'vuex';
import PlatformNotification from './PlatformNotification';
import PlatformNotificationsGroup from './PlatformNotificationsGroup';
import ArchiveNotificationModal from './ArchiveNotificationModal';

export default {
  components: {
    PlatformNotification,
    ArchiveNotificationModal,
    PlatformNotificationsGroup,
  },
  computed: {
    ...mapState('platformNotifications', [
      'pendingArchieveConfirmationAlertData',
      'platformNotifications',
    ]),
  },
  methods: {
  },
};
</script>


<style lang="scss" scoped>
  .app_homepage {
    .platform {
      margin-left: 0;
    }
  }
  .platform {
    position: fixed;
    z-index: 10001;
    margin-left: -$closed-sidepanel-width;
    width: 100%;
    height: 100%;
    background: $black-color12;
  }

  .group {
    transition: transform $transition/2 ease-in;
  }
  .transition-group-enter {
    opacity: 0;
  }
  .transition-group-enter-active {
    transform: translate3d(0, -$notification-group-height/2, 0);
  }
  .transition-group-enter-to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  .transition-group-leave-active {
    transition: $transition/2;
  }
  .transition-group-leave-to {
    opacity: 0;
    transform: translate3d(0, -$notification-group-height/2, 0);
  }
  .transition-group-appear-active {
    transition: $transition/2 ease-in $transition;
    opacity: 0;
  }
  .transition-group-appear-to {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlatformNotifications/index.vue